import React from 'react';
import cn from 'classnames';

import styles from './FormGroup.module.scss';

interface Props extends React.HTMLAttributes<HTMLDivElement> {
  columns?: number;
}

function FormGroup({className, columns = 1, ...restProps}: Props) {
  return (
    <div
      className={cn(styles.root, className, styles[`columns-${columns}`])}
      {...restProps}
    />
  );
}

export default FormGroup;
